import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { path: "/", label: "首页" },
  { path: "/category/zuixin-baoliao", label: "分类浏览" },
  { path: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-xl md:text-2xl font-heading font-bold text-primary-600">
              黑料bu打烊
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path ||
                  (link.path.startsWith("/category") &&
                    location.pathname.startsWith("/category"))
                    ? "text-primary-600"
                    : "text-foreground-700 hover:text-primary-600"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-primary-600 transition-colors"
            aria-label="切换菜单"
          >
            <i
              className={`text-xl ${isMobileOpen ? "ri-close-line" : "ri-menu-line"}`}
            ></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors duration-200 ${
                  location.pathname === link.path ||
                  (link.path.startsWith("/category") &&
                    location.pathname.startsWith("/category"))
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}